export const ADDRESS_FORM_TYPE = {
  DELIVERY: 'delivery',
  INVOICE: 'invoice',
};
